import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { APP_DIALOG_DATA } from '../../components/dialog/dialog.tokens';
import { AppDialogRef } from '../../components/dialog/dialog-ref';
import { DIALOG_IMPORTS } from '../../components/dialog/dialog.imports';

export interface ConfirmDialogData {
  title: string;
  description?: string;
  icon?: string;
  svgIcon?: string;
  warning?: string;
  confirmIcon?: string;
  cancelText?: string;
  confirmText?: string;
  confirmId?: string;
  confirmTestId?: string;
  cancelId?: string;
  cancelTestId?: string;
  compactActions?: boolean;
}

@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [CommonModule, ...DIALOG_IMPORTS, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: 'confirm.component.html',
})
export class ConfirmComponent {
  constructor(
    @Inject(APP_DIALOG_DATA) public data: ConfirmDialogData,
    private dialogRef: AppDialogRef<ConfirmComponent, boolean>,
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
